/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetLogListItemResponseDtoRawLog } from './AssetLogListItemResponseDtoRawLog';
import {
    AssetLogListItemResponseDtoRawLogFromJSON,
    AssetLogListItemResponseDtoRawLogFromJSONTyped,
    AssetLogListItemResponseDtoRawLogToJSON,
    AssetLogListItemResponseDtoRawLogToJSONTyped,
} from './AssetLogListItemResponseDtoRawLog';

/**
 * 
 * @export
 * @interface AssetLogListItemResponseDto
 */
export interface AssetLogListItemResponseDto {
    /**
     * Unique log identifier
     * @type {string}
     * @memberof AssetLogListItemResponseDto
     */
    logId: string;
    /**
     * context.receivedAt from the golden record
     * @type {string}
     * @memberof AssetLogListItemResponseDto
     */
    receivedAt?: string | null;
    /**
     * Whether the log has been treated
     * @type {boolean}
     * @memberof AssetLogListItemResponseDto
     */
    isTreated: boolean;
    /**
     * Document creation timestamp
     * @type {Date}
     * @memberof AssetLogListItemResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {AssetLogListItemResponseDtoRawLog}
     * @memberof AssetLogListItemResponseDto
     */
    rawLog?: AssetLogListItemResponseDtoRawLog | null;
}

/**
 * Check if a given object implements the AssetLogListItemResponseDto interface.
 */
export function instanceOfAssetLogListItemResponseDto(value: object): value is AssetLogListItemResponseDto {
    if (!('logId' in value) || value['logId'] === undefined) return false;
    if (!('isTreated' in value) || value['isTreated'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function AssetLogListItemResponseDtoFromJSON(json: any): AssetLogListItemResponseDto {
    return AssetLogListItemResponseDtoFromJSONTyped(json, false);
}

export function AssetLogListItemResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetLogListItemResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'logId': json['logId'],
        'receivedAt': json['receivedAt'] == null ? undefined : json['receivedAt'],
        'isTreated': json['isTreated'],
        'createdAt': (new Date(json['createdAt'])),
        'rawLog': json['rawLog'] == null ? undefined : AssetLogListItemResponseDtoRawLogFromJSON(json['rawLog']),
    };
}

export function AssetLogListItemResponseDtoToJSON(json: any): AssetLogListItemResponseDto {
    return AssetLogListItemResponseDtoToJSONTyped(json, false);
}

export function AssetLogListItemResponseDtoToJSONTyped(value?: AssetLogListItemResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logId': value['logId'],
        'receivedAt': value['receivedAt'],
        'isTreated': value['isTreated'],
        'createdAt': value['createdAt'].toISOString(),
        'rawLog': AssetLogListItemResponseDtoRawLogToJSON(value['rawLog']),
    };
}

